import {CommonDropdown} from "root/s360components/ReactHookForm/ui/CommonDropdown";
import {EMPTY_ABSENCE_CODE} from "root/s360components/Registration/HookSubFormRegistrationTable";
import './DropdownAbsenceCode.scss';
import SpinnerDiv from "ui/ReactSpinnerDiv";
import React from "react";

export const getAbsenceCode = (code, absenceCodes) =>
{
    let selected_code = EMPTY_ABSENCE_CODE;

    if (code !== "")
    {
        selected_code = absenceCodes.find((item) => item.value === code);
    }

    return selected_code;
}

export const getAbsenceCodes = (data, IncludeEmptyCode) =>
{
    const label = (item) =>
    {
        return item.absence_code === undefined ? item.absence_full_desc : item.absence_code + ' - ' + item.absence_code_desc;
    }

    const absenceCodes = data.map((item, key) => {
        return {value: item.absence_code_id, label: label(item), requires_comment: item.requires_comment}
    });

    return IncludeEmptyCode === true ? [EMPTY_ABSENCE_CODE, ...absenceCodes] : absenceCodes;
}

const DropdownAbsenceCode = ({absence_code, absenceCodes, fieldName, control, readOnly, menuPlacement = 'auto', minMenuHeight = 250}) =>
{
    //Use the absence codes as items/options and use the absence code to find the intial value
    return <div className='dropdown-absence-code'>
        {absenceCodes.length === 0 && <div className='form-control'><SpinnerDiv/></div> }
        {absenceCodes.length !== 0 && <CommonDropdown readOnly={readOnly} items={absenceCodes} control={control} name={fieldName} menuPlacement={menuPlacement} minMenuHeight={250}/>}
    </div>
}

export default DropdownAbsenceCode;